import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Venta } from "@/shared/types/venta";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface PutVentaNumComprobanteRequest {
    numComprobante: string,
    clienteId: string,
}

export async function putVentaNumComprobante(id: string, request: PutVentaNumComprobanteRequest) {
    await sleep(1000);
    const response = await api.put("ventas/" + id, request);
    return response.data
}

export function usePutVentaNumComprobanteMutation(id: string, mutationConfig: MutationConfig<Venta, PutVentaNumComprobanteRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request) => await putVentaNumComprobante(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ventas"] });
        },
    })
}

export interface PutVentaNumComprobanteMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Venta, PutVentaNumComprobanteRequest>
    children?: (mutationResult: MutationResult<Venta, PutVentaNumComprobanteRequest>) => ReactNode
}

export function PutVentaNumComprobanteMutation({
    id,
    children,
    mutationConfig
}: PutVentaNumComprobanteMutationProps) {
    const mutationResult = usePutVentaNumComprobanteMutation(id, mutationConfig);
    return children && children(mutationResult);
}